import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import type { JSX } from 'react';
export const HEADER_TITLE_DEFAULT_ID = 'header-title';
export type HeaderTitleProps = {
  display?: 'flex' | 'block' | 'inline' | 'inline-flex' | 'grid';
  flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  gap?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  icon?: Icon;
  marginBottom?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  marginTop?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  subtitle?: string | JSX.Element;
  title: string | JSX.Element;
  titleElementId?: string;
  zIndex?: number | string;
};
const GAP_CLASS: Record<number, string> = {
  0: 'gap-0',
  1: 'gap-0.5',
  2: 'gap-1',
  3: 'gap-2',
  4: 'gap-3',
  5: 'gap-4',
  6: 'gap-5',
  7: 'gap-6',
  8: 'gap-8'
};
const MT_CLASS: Record<number, string> = {
  0: '',
  1: 'mt-0.5',
  2: 'mt-1',
  3: 'mt-2',
  4: 'mt-3',
  5: 'mt-4',
  6: 'mt-5',
  7: 'mt-6',
  8: 'mt-8'
};
const MB_CLASS: Record<number, string> = {
  0: '',
  1: 'mb-0.5',
  2: 'mb-1',
  3: 'mb-2',
  4: 'mb-3',
  5: 'mb-4',
  6: 'mb-5',
  7: 'mb-6',
  8: 'mb-8'
};
const HeaderTitle = t0 => {
  const $ = _c(28);
  const {
    display,
    flexDirection,
    gap: t1,
    icon: Icon,
    marginTop: t2,
    marginBottom: t3,
    subtitle,
    title,
    titleElementId: t4,
    zIndex
  } = t0;
  const gap = t1 === undefined ? 3 : t1;
  const marginTop = t2 === undefined ? 0 : t2;
  const marginBottom = t3 === undefined ? 0 : t3;
  const titleElementId = t4 === undefined ? HEADER_TITLE_DEFAULT_ID : t4;
  const gapClass = GAP_CLASS[gap] ?? "";
  const mtClass = MT_CLASS[marginTop] ?? "";
  const mbClass = MB_CLASS[marginBottom] ?? "";
  const t5 = display === "block" && "block";
  const t6 = display === "inline" && "inline";
  const t7 = display === "inline-flex" && "inline-flex";
  const t8 = display === "grid" && "grid";
  const t9 = flexDirection === "row" && "flex-row";
  const t10 = flexDirection === "row-reverse" && "flex-row-reverse";
  const t11 = flexDirection === "column-reverse" && "flex-col-reverse";
  let t12;
  if ($[0] !== gapClass || $[1] !== mbClass || $[2] !== mtClass || $[3] !== t10 || $[4] !== t11 || $[5] !== t5 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
    t12 = cx("flex items-center flex-col text-center", gapClass, mtClass, mbClass, t5, t6, t7, t8, t9, t10, t11);
    $[0] = gapClass;
    $[1] = mbClass;
    $[2] = mtClass;
    $[3] = t10;
    $[4] = t11;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] !== zIndex) {
    t13 = {
      zIndex
    };
    $[11] = zIndex;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] !== Icon) {
    t14 = Icon && <Icon color="primary" />;
    $[13] = Icon;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== title || $[16] !== titleElementId) {
    t15 = <h2 className="text-heading-3 text-primary fp-text" id={titleElementId}>{title}</h2>;
    $[15] = title;
    $[16] = titleElementId;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== subtitle) {
    t16 = subtitle && <h3 className="text-body-2 text-secondary fp-text">{subtitle}</h3>;
    $[18] = subtitle;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t15 || $[21] !== t16) {
    t17 = <div className="flex flex-col items-center gap-2">{t15}{t16}</div>;
    $[20] = t15;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== t12 || $[24] !== t13 || $[25] !== t14 || $[26] !== t17) {
    t18 = <div className={t12} style={t13}>{t14}{t17}</div>;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  return t18;
};
export default HeaderTitle;